//@flow
import { type State } from "../../state";
import { type AtivoSelecionado, TIPO_ATIVO_PGBL_VGBL } from "../../model";
import { any, propEq } from "ramda";

export const getAtivosSelecionados = (state: State): Array<AtivoSelecionado> =>
  state.ativosSelecionados || [];

export const isPgblVgblSelecionado = (state: State): boolean =>
  any(propEq("type", TIPO_ATIVO_PGBL_VGBL))(getAtivosSelecionados(state));
